export const KOUNT = {
  // Specifies the mode of the request.
  MODE: {
    Q: 'Q',
    U: 'U',
  },
  // Specifies version of Kount, built into SDK, must be supplied by merchant if not using the SDK.
  VERS: '0723',
  // Merchants acknowledgement to ship/process the order; Y or N
  MACK: {
    Y: 'Y',
    N: 'N',
  },
  MODE_Q: {
    // RIS Parameter for Payment Encoding
    PENC: 'MASK',
    // Country of currency submitted on order. 3 digit ISO code.
    CURR: 'USD',
    // Payment Type submitted by merchant
    PTYP: 'CARD',
    // Website identifier of where order originated.
    SITE: 'Default',
  },
  // Authorization Status returned to merchant from processor. A: Authorized, D: Declined
  AUTHORIZATION_STATUS: {
    A: 'A',
    D: 'D',
  },
  // Omniscore thresholds
  OMNISCORE: {
    APPROVE: 80, // 80% confidence threshold for approval
    REVIEW: 40, // 40% confidence threshold for review
    DECLINE: 20, // 20% confidence threshold for decline
  },
  // Kount 360 API response decision values
  DECISIONS: {
    APPROVE: 'APPROVE',
    REVIEW: 'REVIEW',
    DECLINE: 'DECLINE',
  },
  // Legacy to Kount 360 decision mapping
  LEGACY_AUTO: {
    A: 'APPROVE',
    R: 'REVIEW',
    D: 'DECLINE',
    E: 'REVIEW', // Map escalate to review
  },
  // Kount 360 to Legacy decision mapping
  KOUNT_360_AUTO: {
    APPROVE: 'A',
    REVIEW: 'R',
    DECLINE: 'D',
  },
};

export const KountConfig = {
  // Updated to use Omniscore thresholds
  scoreThreshold: KOUNT.OMNISCORE.REVIEW,
};
